import src from "IMAGE";
export default { src, width: 1480, height: 332, blurWidth: 0, blurHeight: 0};
